// extracted by mini-css-extract-plugin
module.exports = {"mid-gray":"#686461","list":"ErrorList_list__FAKbt","item":"ErrorList_item__2naGU"};